module.exports = __webpack_public_path__ + "static/img/one.3efcda7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/manyRecruitImg/one.png
// module id = 2ym3
// module chunks = 1